var path = 'templates/book/general.html';
var html = "<div class flex=30 layout=column> <h3>{{book.title}}</h3> <img ng-src=./resources/img/thumbnails/{{book.$id}}.min.jpg /> </div> <div class flex layout=column> <p>ID: {{book.$id}}</p> <p> <a href={{book.bib_url}} target=_blank>東京大学地震研究所所蔵 </a> </p> <p>{{book.comment}}</p> <p><a class=\"disaster tag\" ng-click=\"searchByTag(d['name'])\" ng-repeat=\"d in entry.disaster_list\"> {{d['name']}} <md-tooltip md-direction=bottom> {{d['name']}}（{{d['jp_date']}}）[{{d['en_date']}}] </md-tooltip> </a> <a class=\"region tag\" ng-repeat=\"region in entry.region_list\"> {{region}} <md-tooltip md-direction=bottom> 地域: {{region}} </md-tooltip> </a> </p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/book/general.html
// module id = 3
// module chunks = 0